import React, { Component } from 'react';
import { trackEvent } from 'react-with-analytics';

import imageChevronLtr from '../images/chevron-ltr.png';

class DemandeDeDevis extends Component {
    constructor(props) {
        super(props);

        this.doClick = this.doClick.bind(this);
    }

    doClick() {
        let buttonId = this.props['buttonId'] ? this.props['buttonId'] : 'Devis';
        trackEvent('Interactions', 'Ouverture de formulaire', buttonId);

        this.props.onClick();
    }

  render() {
    return (
        <span onClick={this.doClick} className="btn btn-black">Demande de devis <img src={imageChevronLtr} alt="" /></span>
    );
  }
}

export default DemandeDeDevis;



// WEBPACK FOOTER //
// ./src/components/DemandeDeDevis.js